var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 1.285C6.737.718 5.43.4 4.05.4S1.363.718.2 1.285v11a8.765 8.765 0 0 1 3.85-.885A8.76 8.76 0 0 1 9 12.923a8.76 8.76 0 0 1 4.95-1.523c1.38 0 2.687.318 3.85.885v-11A8.764 8.764 0 0 0 13.95.4c-1.38 0-2.687.318-3.85.885V9.2a1.1 1.1 0 0 1-2.2 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.0b6d272d200dd30fce97ed43835b5e7c.svg";
export { ForwardRef as ReactComponent };